import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogOverlay, DialogTitle } from "@/components/ui/dialog"
import { useDispatch, useSelector } from "react-redux"
import { SET_REFERRAL_DIALOG, SET_SHOW_LOGIN, SET_USER } from "@/redux/features/auth/authSlice"
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";
import { Loader2, Gem, Copy } from "lucide-react";

const ReferralDialog = () => {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const { referralDialog, user } = useSelector(state => state.auth)
    const onOpenChange = (value) => {
        dispatch(SET_REFERRAL_DIALOG(value))
        if (value === false) {
            setTimeout(() => {
                document.body.style.removeProperty('pointer-events');
            }, 500);
        }
    }

    const generateReferralLink = async () => {
        if (user?.is_guest) {
            dispatch(SET_REFERRAL_DIALOG(false))
            dispatch(SET_SHOW_LOGIN(true))
            return toast.error("Please login to generate referral link", { id: "guest" })
        }
        const token = localStorage.getItem('token')
        try {
            setLoading(true)
            toast.loading("Generating Referral Link...", { id: "referral-link" })
            const response = await axios.post("/referral/generate", {}, { headers: { Authorization: `Bearer ${token}` } })
            const updatedUser = { ...user, referral_link: response.data?.referral_link }
            dispatch(SET_USER(updatedUser))
            toast.success("Referral Link Generated", { id: "referral-link" })
        } catch (error) {
            console.log(error)
            toast.error(error.response?.data?.detail || error.message || "Something went wrong", { id: "referral-link" })
        } finally {
            setLoading(false)
        }
    }

    const copyReferralLink = () => {
        navigator.clipboard.writeText(user?.referral_link)
        toast.success("Referral Link Copied", { id: "referral-link" })
    }

    const shareReferralLink = async () => {
        const shareText = `Join this cool platform where you can generate free AI songs!
Join from the link and you'll get 500 free credits:

${user?.referral_link}`;
        try {
            if (navigator.share) {
                await navigator.share({
                    text: shareText
                });
            } else {
                copyReferralLink()
            }
        } catch (error) {
            console.error("Error sharing:", error);
            toast.error("Failed to share", { id: "referral-link" });
        }
    }

    return (
        <Dialog open={referralDialog} onOpenChange={onOpenChange}>
            <DialogOverlay className="z-[999]">
                <DialogContent className=" z-[9999] max-w-[90%] w-full xs:max-w-md p-4 rounded-lg bg-gradient-to-br from-slate-950 to-slate-800 dark:from-pink-100 dark:to-pink-300 text-slate-200 border border-green-800/60 dark:border-pink-800/60 mx-auto overflow-hidden">
                    <DialogHeader>
                        <DialogTitle className="text-xl font-semibold text-green-400 dark:text-pink-900 font-potta flex items-center gap-2">
                            Refer and Earn
                            <Gem size={18} />
                        </DialogTitle>
                        <DialogDescription className="text-sm text-left text-slate-400 dark:text-pink-600 font-poppins font-medium">
                            Share your referral link with your friends and family to earn free credits. You and your friends will get 500 credits each.
                        </DialogDescription>
                    </DialogHeader>
                    {user?.referral_link ? <div className="flex gap-2 items-center w-full truncate">
                        <p onClick={() => copyReferralLink()} className="text-sm flex-grow text-green-400/90 dark:text-pink-900 font-poppins font-medium truncate bg-black dark:bg-pink-100 rounded-md p-2 ">{user?.referral_link}</p>
                        <button onClick={copyReferralLink} type="button" className="w-6 h-6 bg-green-500 hover:bg-green-400 text-black dark:bg-pink-500 dark:hover:bg-pink-400 dark:text-pink-900 flex items-center justify-center rounded font-medium"><Copy className="ml-0.5" size={16} /></button>
                    </div> : <button disabled={loading} className="disabled:opacity-80 disabled:cursor-not-allowed text-sm bg-green-500 hover:bg-green-400 text-black dark:bg-pink-900 dark:hover:bg-pink-800 dark:text-black px-4 py-2 rounded w-full font-medium flex items-center justify-center" onClick={generateReferralLink}> {loading && <Loader2 className="mr-2 animate-spin" size={16} />} {loading ? "Generating..." : "Generate Referral Link"}</button>}
                    {user?.referral_link && <button onClick={shareReferralLink} type="button" className="text-sm bg-green-500 hover:bg-green-400 text-black dark:bg-pink-700 dark:hover:bg-pink-600 dark:text-white px-4 py-2 rounded w-full font-medium">Share Referral Link</button>}
                </DialogContent>
            </DialogOverlay>
        </Dialog>
    )
}

export default ReferralDialog